import React from "react";

function Footer() {
  return (
    <footer className="footer--container">
      <div className="footer--link--container">
      </div>
      <hr className="divider" />
      <div className="footer--content--container">
        <p className="footer--content">Made with 🎔, by Luara Kelly!</p>
      </div>
    </footer>
  );
}

export default Footer;